import React, { ReactNode } from "react";

import AntDTabs from "antd/es/tabs";
import { useIntl } from "react-intl";

import DnDTabs from "@app/component/DnDTabs";
import getTabDisplayName from "@app/component/preview/CompanyRecordPane/Content/getTabDisplayName";
import RecordPaneTab from "@app/enum/preview/RecordPaneTab";

import styles from "./Tabs.module.scss";

interface TabProps {
  children?: ReactNode;
  tab: RecordPaneTab;
}

interface Props {
  activeTab?: RecordPaneTab;
  className?: string;
  defaultTabsOrder: RecordPaneTab[];
  onActiveTabRefChange?: (ref: HTMLDivElement | null) => void;
  onChange: (tab: RecordPaneTab) => void;
  onOrderChange: (tabsOrder: RecordPaneTab[]) => void;
  tabs: TabProps[];
}

const Tabs: React.FC<Props> = ({
  activeTab,
  className,
  defaultTabsOrder,
  onActiveTabRefChange,
  onChange,
  onOrderChange,
  tabs,
}) => {
  const intl = useIntl();

  return (
    <DnDTabs
      activeKey={activeTab}
      className={className}
      defaultTabsOrder={defaultTabsOrder}
      destroyInactiveTabPane
      onChange={onChange as (tab: string) => void}
      onDragEnd={onOrderChange as (tabsOrder: string[]) => void}
    >
      {tabs.map(({ children, tab }) => (
        <AntDTabs.TabPane key={tab} tab={getTabDisplayName(intl, tab)}>
          <div className={styles.tabContainer} ref={onActiveTabRefChange}>
            {children}
          </div>
        </AntDTabs.TabPane>
      ))}
    </DnDTabs>
  );
};

export default Tabs;
